import { forwardRef, type InputHTMLAttributes } from 'react'
import { cn } from '../lib/cn'
import { FieldShell, fieldDescribedBy, inputClass, useFieldId, type FieldChromeProps } from './field'

export type InputProps = FieldChromeProps & Omit<InputHTMLAttributes<HTMLInputElement>, 'size'>

/** Labelled text input: stable auto `id` + `htmlFor` (AUDIT_FIXES_JULY27 J1).
 * For `type="file"` use `FileInput`, which styles the native chooser button. */
export const Input = forwardRef<HTMLInputElement, InputProps>(function Input(
  { label, hideLabel, help, error, size, wrapperClassName, id, className, required, ...rest },
  ref,
) {
  const fieldId = useFieldId(id)
  return (
    <FieldShell
      id={fieldId}
      label={label}
      hideLabel={hideLabel}
      help={help}
      error={error}
      required={required}
      wrapperClassName={wrapperClassName}
    >
      <input
        ref={ref}
        id={fieldId}
        required={required}
        aria-invalid={error ? true : undefined}
        aria-describedby={fieldDescribedBy(fieldId, help, error)}
        className={cn(inputClass(size), 'w-full disabled:opacity-50', className)}
        {...rest}
      />
    </FieldShell>
  )
})
